// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3WdDv","footer":"ModalCreateQualiphyProcedure_footer__2FO7k","additionData":"ModalCreateQualiphyProcedure_additionData__3Swqr"};